import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom'
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';

import Typography from '@material-ui/core/Typography';

const styles = {
  description: {
      height: '100px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
  },
  cardAction: {
      display: 'block',
      width: 345,
  },
  card: {
    width: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
};

function VideoCard(props) {
  const { classes, video } = props;
    console.log(video);
  return (
    <div>
      <Card className={classes.card}>
        <ButtonBase
            className={classes.cardAction}
            onClick={event => props.history.push(`/video/${video.pk}`)}
        >
          {/*<CardHeader
                avatar={
                    <Avatar aria-label="Video" className={classes.avatar}>
                        YT
                    </Avatar>
                }
                title={video.fields.title}
            />*/}
            <CardMedia
              className={classes.media}
              image={`https://img.youtube.com/vi/${video.fields.external_id}/mqdefault.jpg`}
              title={video.fields.title}
            />
            <CardContent>
              <Typography gutterBottom variant="headline" component="h2">{video.fields.title}</Typography>
              <Typography className={classes.description} component="p">{video.fields.description}</Typography>
            </CardContent>
        </ButtonBase>
                  {/*<CardActions>
          <Button size="small" color="primary">
            Renditions
          </Button>
          <Button size="small" color="primary" disabled="disabled">
            Entities
          </Button>
        </CardActions>*/}
      </Card>
    </div>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(VideoCard));



// WEBPACK FOOTER //
// ./src/components/video_card.jsx